import React from "react";

import { type Place } from "@xapp/components";

import classes from "./style.scss";

/**
 * Get the header for the current step
 */
export function getStepHeader(step: string, place?: Place, params?: URLSearchParams): React.ReactNode | undefined {
    // const partner = params?.get("partner") || "";
    const header1 = params?.get("header1") || "";

    switch (step) {
        case "intent":
            return <span className={classes.hideMobile}>Welcome!</span>;
        case "post_payment":
            return <span>Congratulations! Your subscription is active</span>;
        case "availability":
            return <span>Let's set up your calendar availability</span>;
        case "data_collection":
            return <span>What information do you want to gather?</span>;
        case "ai_information":
            return <span>AI Training</span>;
        case "lead_destination":
            return <span>Where should we send your leads?</span>;
        case "completion":
            return <span>Setup Complete!</span>;
        case "business_info":
            if (header1) {
                return <span>{header1}</span>;
            } else {
                return <span>Are you Eligible?</span>;
                // return <span>Tell us about your business</span>;
            }
        case "find_confirm_profile":
            return <span>Confirm your Business</span>;
        case "customize":
            return <span>Congratulations, you are eligible!</span>;
        case "find_profile":
        case "confirm_profile":
            return (
                <span>
                    Train your <span style={{ color: "#1aa7dc" }}>AI Agent</span>{" "}
                    <span style={{ color: "gray" }}>to Book Jobs & Capture Leads</span>
                </span>
            );
        case "use_website":
            return (
                <span>
                    Train your <span style={{ color: "#1aa7dc" }}>AI Agent</span> with your website
                </span>
            );
        case "training":
            return (
                <span>
                    Training <span style={{ color: "#1aa7dc" }}>AI Agent</span>
                </span>
            );
        case "claim_agent":
            //change depending on if we have a place or not
            if (place) {
                return (
                    <span>
                        {place?.name}'s <span style={{ color: "#1aa7dc" }}>AI Agent</span> Powers Google Book Online
                    </span>
                );
            } else {
                return (
                    <span>
                        Claim your <span style={{ color: "#1aa7dc" }}>AI Agent</span>
                    </span>
                );
            }
        // case "sign_up":
        //     return <span>Let's save your progress, please create an account.</span>;
        case "checkout":
            return <span>No Additional Cost Per Lead</span>;
        default:
            return undefined;
    }
}

/**
 * Get the aside content for the current step
 */
export function getStepAside(step: string, place?: Place, params?: URLSearchParams): React.ReactNode | undefined {
    // const partner = params?.get("partner") || "";

    const bullet1 = params?.get("bullet1") || "";
    const bullet2 = params?.get("bullet2") || "";
    const bullet3 = params?.get("bullet3") || "";

    switch (step) {
        case "intent":
            return (
                <ul className={classes.asideList}>
                    <li>
                        <b>We can help you book more potential business</b>
                    </li>
                    <li>Simplified booking and lead capture powered by AI help capture more leads</li>
                    <li>Capture leads directly on your Google Business Profile from Google Search & Maps</li>
                </ul>
            );
        case "post_payment":
            return (
                <ul className={classes.asideList}>
                    <li>
                        <b>Your book online will be live within 48 hours.</b>
                    </li>
                    <li>Watch this short video to learn how your new system works</li>
                    <li>We'll help you set everything up in just a few minutes</li>
                </ul>
            );
        case "availability":
            return (
                <ul className={classes.asideList}>
                    <li>
                        <b>Configure your service schedule</b>
                    </li>
                    <li>Select which days you provide service to block out unavailable days</li>
                    <li>Set same-day booking preferences or minimum advance notice</li>
                    <li>This helps reduce the back and forth with the customer on selecting a date</li>
                </ul>
            );
        case "data_collection":
            return (
                <ul className={classes.asideList}>
                    <li>
                        <b>Set up your booking form</b>
                    </li>
                    <li>Choose which initial contact options to offer</li>
                    <li>Select essential customer information to collect</li>
                    <li>Keep it simple - you can add more fields later</li>
                </ul>
            );
        case "ai_information":
            return (
                <ul className={classes.asideList}>
                    <li>
                        <b>Personalize your AI assistant</b>
                    </li>
                    <li>Help your AI understand your specific business and services</li>
                    <li>Define what makes a lead valuable to prioritize opportunities</li>
                    <li>Better context leads to more effective customer interactions</li>
                </ul>
            );
        case "lead_destination":
            return (
                <ul className={classes.asideList}>
                    <li>
                        <b>Connect your leads and bookings</b>
                    </li>
                    <li>Send leads to your CRM or Field Service Management system</li>
                    <li>Set up email notifications for new bookings & leads</li>
                    <li>Never miss a potential customer again</li>
                </ul>
            );
        case "completion":
            return (
                <ul className={classes.asideList}>
                    <li>
                        <b>Congratulations! Your AI booking system is ready</b>
                    </li>
                    <li>Google Book Online button will be live within 48 hours</li>
                    <li>You'll receive an email notification when it goes live</li>
                    <li>All settings can be modified from your dashboard</li>
                </ul>
            );
        case "find_profile":
            return (
                <ul className={classes.asideList}>
                    <li>
                        <b>Find your profile </b> by entering your business name
                    </li>
                    <li>
                        Your <span style={{ color: "#1aa7dc" }}>AI agent</span> will be trained on your profile and on
                        your website if you have one
                    </li>
                    <li>Takes less than a minute!</li>
                </ul>
            );
        case "business_info":
            return (
                <ul className={classes.asideList}>
                    <li>
                        {bullet1 ? (
                            <>{bullet1}</>
                        ) : (
                            <>
                                <b>Tell us about your business </b> to help us find your profile
                            </>
                        )}
                    </li>
                    <li>
                        {bullet2 ? (
                            <>{bullet2}</>
                        ) : (
                            <>
                                Your <span style={{ color: "#1aa7dc" }}>AI agent</span> will be trained on your profile
                                and on your website if you have one
                            </>
                        )}
                    </li>
                    <li>{bullet3 ? <>{bullet3}</> : <>Takes less than a minute!</>}</li>
                </ul>
            );
        case "customize":
            return (
                <ul className={classes.asideList}>
                    {/*<li>
                        Your <b>new Google book online button</b> will be available in 24-48 hours
                    </li> */}

                    <li>
                        Businesses with a Google Book Online button receive <b>50%</b> more automated bookings
                    </li>
                    <li>Expect the Book Online button to appear within 24-48 hours after activation & approval</li>
                    <li>
                        Customize your booking experience after your subscription starts (style, fields, availability,
                        etc.)
                    </li>
                </ul>
            );
        case "advanced_search":
            return (
                <ul className={classes.asideList}>
                    <li>Let's try to find your profile it with more information</li>
                    <li>
                        Your <span style={{ color: "#1aa7dc" }}>AI agent</span> will be trained on your profile and on
                        your website if you have one
                    </li>
                    <li>If we still can't find it, we can still proceed</li>
                </ul>
            );
        case "confirm_profile":
            return (
                <ul className={classes.asideList}>
                    <li>
                        Your <span style={{ color: "#1aa7dc" }}>AI agent</span> will be trained on your profile and on
                        your website if you have one
                    </li>
                    <li>Takes less than a minute!</li>
                </ul>
            );
        case "use_website":
            return (
                <ul className={classes.asideList}>
                    <li>
                        <b>Enter your website </b> to train your <span style={{ color: "#1aa7dc" }}>AI Agent</span>
                    </li>
                    <li>
                        Your <span style={{ color: "#1aa7dc" }}>AI agent</span> will be trained on your profile and on
                        your website if you have one
                    </li>
                    <li>Takes less than a minute!</li>
                </ul>
            );
        case "training":
            return (
                <ul className={classes.asideList}>
                    <li>
                        Your <span style={{ color: "#1aa7dc" }}>AI Agent</span> is being trained
                    </li>
                    <li>Initial training takes just a few seconds.</li>
                </ul>
            );
        case "claim_agent":
            if (place) {
                return (
                    <ul className={classes.asideList}>
                        <li>
                            Your <span style={{ color: "#1aa7dc" }}>AI agent</span> was trained on your data
                        </li>
                        <li>
                            Adds <span style={{ color: "#1aa7dc" }}>Book Online</span> to your Google Business Profile
                        </li>
                        <li>
                            <b>Claim your AI Agent</b> to book jobs directly from your Google Business Profile and
                            Google Maps
                        </li>
                    </ul>
                );
            } else {
                return (
                    <ul className={classes.asideList}>
                        <li>
                            Your <span style={{ color: "#1aa7dc" }}>AI agent</span> will be trained on your data.
                        </li>
                        <li>Your agent will power website bookings and lead capture</li>
                        <li>Install on your website or use our customizable hosted page</li>
                    </ul>
                );
            }
        case "sign_up":
            return (
                <ul className={classes.asideList}>
                    <li>Sign up to claim your AI Agent for your Google Business Profile</li>
                    <li>Expect the Book Online button to appear within 48 hours</li>
                    <li>Your credentials & email will be used to verify you are related to the business</li>
                </ul>
            );
        default:
            return undefined;
    }
}
